import React, { useEffect, useMemo, useState } from 'react';
import { useSingleEffect } from 'react-haiku';
import { useParams } from 'react-router-dom';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import Pages from 'components/Misc/Pages';
import Nothing from 'components/Misc/Nothing';
import Progress from 'components/Misc/Progress';

import Bulk from 'containers/Administrator/Courses/Profile/Students/Bulk';
import Search from 'containers/Administrator/Courses/Profile/Students/Search';
import Student from 'containers/Administrator/Courses/Profile/Students/Student';
import Selector from 'containers/Administrator/Courses/Profile/Students/Selector';

import { useCourseStudentsStore } from 'store/course/useCourseStudentsStore';

// Implement bulk start and end date edit
const Students = ({ tab, setTab }) => {
	// Store current object's id
	const { id } = useParams();

	// Update selected tab on mount
	useSingleEffect(() => setTab(tab));

	// Use grade student store
	const [result, data, parameters, search, onSearch, onTogglePage, onToggleAll, onInit, onReset] = useCourseStudentsStore(state => [
		state.result,
		state.data,
		state.parameters,
		state.search,
		state.onSearch,
		state.onTogglePage,
		state.onToggleAll,
		state.onInit,
		state.onReset
	]);

	// Store requested students
	const [[, progress], collect] = useCollect(`courses/${id}`, parameters, onInit);

	// Collect exam on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	// Reset course's data on unmount
	useEffect(() => {
		return () => onReset();
	}, []);

	return (
		<div className="space-y-4">
			{/* Search container */}
			<Search />

			{/* Bulk selection update */}
			<Bulk />
					
			{/* Show loading progress */}
			<Progress progress={progress} />

			{/* Show nothing found */}
			<Nothing visible={!result.total && !progress} />

			{/* Show students if collected */}
			<div className="w-full bg-white dark:bg-neutral-800 rounded-lg">
				<table className="w-full">
					<thead>
						<tr>
							<th className="pl-3 py-3 text-neutral-500 text-sm font-normal text-left">
								<Selector
									selected={data.selected.some(id => result.students.find(s => s.student.id === id))}
									onToggleAll={onToggleAll}
									onTogglePage={onTogglePage}
								/>
							</th>
							<th className="px-3 py-3 text-neutral-500 text-sm font-normal text-left">Students</th>
							<th className="px-3 py-3 text-neutral-500 text-sm font-normal text-left">Sākuma datums</th>
							<th className="px-3 py-3 text-neutral-500 text-sm font-normal text-left">Beigu datums</th>
							<th className="px-3 py-3 text-neutral-500 text-sm font-normal text-left">Statuss</th>
							<th className="pr-3 py-3 text-neutral-500 text-sm font-normal text-left"></th>
							<th className="pr-3 py-3 text-neutral-500 text-sm font-normal text-left"></th>
						</tr>
					</thead>

					<tbody>
						{result.students.map(student =>
							<Student key={student.id} relation={student} />
						)}
					</tbody>
					
					<tfoot>
						<tr>
							<td colSpan="7" className="px-3 py-2">
								<Pages
									total={result.total}
									active={search.page}
									onChange={onSearch}
								/>
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</div>
	);
};

export default Students;